































































































































































import mixins from 'vue-typed-mixins';
import DataSetUtils, { DataSet, DataSetContent } from '@/utils/DataSetUtils';
import cloneDeep from 'lodash.clonedeep';
import OversightUtils, {
  OversightOrganization,
  OversightOrganizationType,
} from '@/utils/OversightUtils';
export default mixins().extend({
  props: {
    dataset: {
      type: Object as () => DataSet,
    },

    editable: {
      type: Boolean as () => boolean,
    },
  },

  computed: {
    table(): any {
      return {
        items: this.items,
        headers: [
          { text: this.$tc('model.dataset.content.id'), value: 'id' },
          { text: this.$tc('model.dataset.content.name'), value: 'name' },
          {
            text: this.$tc('model.dataset.content.oversights', 2),
            value: 'oversights.name',
          },
        ],
      };
    },

    oversightOptions(): any {
      return this.oversights
        ?.filter(
          (oversight) =>
            oversight.oversighttype?.id === this.dataset?.oversighttype?.id
        )
        ?.map((oversight) => ({
          text: this.$translate(oversight.name),
          value: oversight,
        }));
    },

    importModalModeOptions(): any {
      return [
        {
          text: this.$tc('page.dataset.import.mode.ignoreduplicate'),
          value: 'ignoreduplicate',
        },
        { text: this.$tc('page.dataset.import.mode.purge'), value: 'purge' },
      ];
    },
  },

  data(): {
    items?: DataSetContent[];
    oversights?: OversightOrganization[];
    modal?: {
      item: Partial<DataSetContent>;
      content: string;
    };
    importModal?: {
      mode: 'ignoreduplicate' | 'purge';
      file?: any;
      inprogress: boolean;
    };
  } {
    return {
      items: undefined,
      oversights: undefined,
      modal: undefined,
      importModal: undefined,
    };
  },

  async mounted() {
    this.loadContent(); // async load
    this.loadOversights(); // async load
  },

  watch: {
    oversightOptions() {
      if (this.oversightOptions && this.modal?.item) {
        this.modal.item.oversights =
          this.oversightOptions.filter((option: any) => {
            const index = this.modal?.item?.oversights?.findIndex(
              (value) => value.id === option.value.id
            );
            return (index !== undefined ? index : -1) >= 0;
          }) || [];
      }
    },

    dataset() {
      if (this.dataset) {
        this.loadContent(); // async load
        this.loadOversights(); // async load
      }
    },
  },

  methods: {
    create() {
      this.modal = {
        item: {
          dataset: this.dataset,
          name: this.$languageobj(),
          oversights: [],
          content: {},
        },
        content: '',
      };
    },

    edit(item: DataSetContent) {
      const clone = cloneDeep(item);

      if (this.oversightOptions) {
        clone.oversights =
          this.oversightOptions.filter((option: any) => {
            const index = clone.oversights?.findIndex(
              (value) => value.id === option.value.id
            );
            return (index !== undefined ? index : -1) >= 0;
          }) || [];
      }

      if (this.editable) {
        this.modal = {
          item: clone,
          content: JSON.stringify(item.content || {}),
        };
      }
    },

    exit() {
      this.modal = undefined;
    },

    async remove(item: DataSetContent) {
      try {
        await this.$confirm(
          this.$i18n
            .t('validation.confirmation.delete', [this.$translate(item.name)])
            .toString(),
          async () => {
            if (this.items) {
              await DataSetUtils.api.content.remove(item.id);

              this.$toast.push({
                type: 'success',
                text: this.$languageobj('validation.success.delete', {
                  values: [this.$translate(item.name)],
                }),
              });

              const index = this.items.findIndex((val) => val.id === item.id);
              if (index >= 0) {
                this.items.splice(index, 1);
              }
            }
          }
        );
      } catch (error) {
        this.$alert.show('remove', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async importCSV() {
      if (this.importModal) {
        try {
          this.importModal.inprogress = true;

          this.$alert.hide('importCSV');
          await DataSetUtils.api.content.import(
            this.importModal.file,
            this.dataset.id,
            this.importModal.mode
          );

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('page.dataset.validate.import'),
          });

          this.importModal = undefined;
          this.loadContent(); // async load
        } catch (error) {
          this.$alert.show('importCSV', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
          if (this.importModal) {
            this.importModal.inprogress = false;
          }
        }
      }
    },

    async exportCSV() {
      try {
        this.$alert.hide('exportCSV');
        await DataSetUtils.api.content.export(this.dataset);
      } catch (error) {
        this.$alert.show('exportCSV', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async save() {
      if (this.modal) {
        try {
          (this.$refs.alert as any).hide('save');
          this.modal.item.content = JSON.parse(this.modal.content);
          try {
            let datasetcontent: DataSetContent;
            if (this.modal.item?.id) {
              datasetcontent = await DataSetUtils.api.content.update(
                this.modal.item
              );
            } else {
              datasetcontent = await DataSetUtils.api.content.add(
                this.modal.item
              );
            }

            if (this.items) {
              const index = this.items.findIndex(
                (content) => content.id === datasetcontent.id
              );
              if (index >= 0) {
                this.items[index] = datasetcontent;
              } else {
                this.items.push(datasetcontent);
              }
            }

            this.exit();
          } catch (error) {
            (this.$refs.alert as any).show('save', {
              type: 'error',
              messages: this.$handleAPIError(error),
            });
          }
        } catch (error) {
          (this.$refs.alert as any).show('save', {
            type: 'error',
            messages: [this.$tc('page.dataset.validate.invalidJSON')],
          });
        }
      }
    },

    async loadContent() {
      try {
        this.$alert.hide('loadContent');
        this.items = undefined;
        this.items =
          (await DataSetUtils.api.content.list(this.dataset.key)) || [];
      } catch (error) {
        this.$alert.show('loadContent', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async loadOversights() {
      try {
        this.$alert.hide('loadOversights');
        this.oversights = undefined;
        this.oversights = await OversightUtils.api.instance.list();
      } catch (error) {
        this.$alert.show('loadOversights', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
